import React, { createContext, useContext, useMemo } from "react";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import {
  findUserNotesModule,
  isUserNotesSubscribed,
} from "../../platform_spaces/space/userNotesEntitlement";

type UserNotesEntitlementValue = {
  notesModule: MembershipProduct | null;
  notesEntitled: boolean;
};

const UserNotesEntitlementContext = createContext<UserNotesEntitlementValue>({
  notesModule: null,
  notesEntitled: false,
});

export function UserNotesEntitlementProvider(props: {
  membershipProducts: MembershipProduct[];
  children: React.ReactNode;
}): JSX.Element {
  const { membershipProducts, children } = props;
  const value = useMemo(
    () => ({
      notesModule: findUserNotesModule(membershipProducts),
      notesEntitled: isUserNotesSubscribed(membershipProducts),
    }),
    [membershipProducts]
  );
  return (
    <UserNotesEntitlementContext.Provider value={value}>
      {children}
    </UserNotesEntitlementContext.Provider>
  );
}

export function useUserNotesEntitlement(): UserNotesEntitlementValue {
  return useContext(UserNotesEntitlementContext);
}
